// default PX is 16
export const Breakpoints = {
    xs: '23em', // 320px
    sm: '35em', // 560px
    md: '48em', // 768px
    lg: '62em', // 992px
    xl: '80em', // 1280px
    '2xl': '96em', // 1536px
    '3xl': '120em', // 1920px
};
